import _ from 'lodash';
import validator from 'validator';

function isInteger (value) {
    if (_.isInteger(value)) {
        return true;
    }
    return !_.isEmpty(value) && validator.isInt(value);
}

export default isInteger;
